import React from 'react';
import { IAvailability } from './IAvailabilityCmp';
import { useAppContext } from '@/context/state';
import ImageWithTextBlock from '@/components/organisms/ImageWithTextBlock';
import { IImageWithTextBlock } from '@/types/contentful/contentful';
import { BLOCKS, Document } from '@contentful/rich-text-types';
import { calculateAvailability } from '@/utils/availability';

const Availability: React.FC<IAvailability> = ({
  delivery_time,
  availabilityInfos,
}) => {
  let content = null;
  const context = useAppContext();
  const dispatchDateRangeDays = context?.settings?.dispatchDateRangeDays;
  const threshold = context?.settings?.deliveryTime;

  if (
    threshold &&
    dispatchDateRangeDays &&
    delivery_time &&
    delivery_time < threshold
  ) {
    const p = replaceRangeDatePlaceholder(
      availabilityInfos['readyToDispatch'],
      delivery_time,
      dispatchDateRangeDays
    );

    content = <ImageWithTextBlock {...p} index={1} />;
  }

  if (
    threshold &&
    delivery_time &&
    dispatchDateRangeDays &&
    delivery_time >= threshold
  ) {
    const p = replaceRangeDatePlaceholder(
      availabilityInfos['toBeCrafted'],
      delivery_time,
      dispatchDateRangeDays
    );
    content = <ImageWithTextBlock {...p} index={1} />;
  }

  return <>{content}</>;
};

export default Availability;

const replaceRangeDatePlaceholder = (
  availabilityBlock: IImageWithTextBlock,
  deliveryTime: number,
  dispatchDateRange: number
) => {
  const { fromDate, toDate } = calculateAvailability(
    deliveryTime,
    dispatchDateRange
  );

  let estimatedDateImageWithText;
  if (
    availabilityBlock?.fields?.imageWithText &&
    availabilityBlock?.fields?.imageWithText[1]
  ) {
    estimatedDateImageWithText = availabilityBlock.fields.imageWithText[1];
  }

  const document: Document = {
    nodeType: BLOCKS.DOCUMENT,
    data: {},
    content: [
      {
        nodeType: BLOCKS.PARAGRAPH,
        data: {},
        content: [
          {
            nodeType: 'text',
            value: `${fromDate} - ${toDate}`,
            data: {},
            marks: [],
          },
        ],
      },
    ],
  };

  if (estimatedDateImageWithText) {
    estimatedDateImageWithText.fields.descriptionRich = document;
  }

  return availabilityBlock;
};
